import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { CoursePreviewCard, CoursePreviewProps } from '~/components';

import type { SetVideoPlayerType } from '../SetVideoPlayerType';

export const CoursePreviews: React.FC<
  PropsWithChildren<{
    previews: CoursePreviewProps;
    setVideoPlayer: SetVideoPlayerType;
  }>
> = ({ previews, setVideoPlayer }) => {
  return (
    <Box mt="60px">
      <Grid container justifyContent="center" spacing={4}>
        {previews.data?.map((item, key) => (
          <Grid item xs={12} md={6} key={key} style={{ paddingTop: '0px' }}>
            <CoursePreviewCard item={item} onClick={() => setVideoPlayer(item.video)} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
